import { twMerge } from "tailwind-merge";
import Heading from "../Heading";
import styles from "./SectionList.module.css";

interface ISectionList {
  title?: string | React.ReactNode;
  isTranslucent: boolean;
  className?: string;
  children?: React.ReactNode;
  isCondensed?: boolean;
}

function SectionList({ title, className, isTranslucent = true, children, isCondensed = false }: ISectionList) {
  return (
    <section className="my-4 lg:my-8 flex flex-col gap-0">
      {title && <Heading as="h3" className="mb-2">{title}</Heading>}
      <div className={twMerge(isTranslucent && "bg-darkglass", "rounded-xl", styles.sectionList, isCondensed && styles.sectionList__condensed, className)}>{children}</div>
    </section>
  );
}

export default SectionList;
